import React from "react";

const RoomServicePage = () => {
  return <h2>Room Service Page</h2>;
};

export default RoomServicePage;
